import { createSelector } from 'reselect';

export const getCompanyList = state => state.company.companyList;
export const getCompanyListData = createSelector(getCompanyList, companyList => companyList?.data);
export const getCompanyListTotal = createSelector(getCompanyList, companyList => companyList?.total);
export const getMyCompanyList = state => state.company.myCompanyList;
export const getMyCompanyListData = createSelector(getMyCompanyList, myCompanyList => myCompanyList?.data);
export const getMyCompanyListTotal = createSelector(getMyCompanyList, myCompanyList => myCompanyList?.total);
export const getCompany = state => state.company.company;
export const getCompanyAnalytics = state => state.company.companyAnalytics;
export const getLoadingStatus = state => state.company.loading;
export const getSavingStatus = state => state.company.saving;
export const getExportingStatus = state => state.company.exporting;
export const getErrorStatus = state => state.company.error;
